module.exports = __webpack_public_path__ + "img/sdx-wepublic.6551bb8b.png";